export default ({
  namespaced: true,
  state: {
    accessToken: '',
    userData: {},
    isManager: false,
    managerData: {}
  },
  getters: {
    getAccessToken(state) {
      state.accessToken = state.accessToken || localStorage.accessToken
      return state.accessToken
    },
    getUserData(state) {
      state.userData = (localStorage.userData) || '{}'
      return JSON.parse(state.userData)
    },
    getIsManager(state) {
      state.isManager = localStorage.isManager
      return state.isManager
    },
    getManagerData(state) {
      state.managerData = (localStorage.managerData) || '{}'
      return JSON.parse(state.managerData)
    }
  },
  mutations: {
    storeLogin(state, {accessToken = '', userData}) {
      state.userData = userData
      state.accessToken = accessToken
      localStorage.userData = userData
      localStorage.accessToken = accessToken
    },
    setUserData(state, {userData = {}}) {
      state.userData = userData
      localStorage.userData = userData
    },
    storeLogout(state) {
      state.userData = null
      state.accessToken = null
      delete localStorage.accessToken
      delete localStorage.userData
    },
    setIsManager(state, isManager = false) {
      state.isManager = isManager
      localStorage.isManager = isManager
    },
    setManagerData(state, {managerData}) {
      state.managerData = managerData
      localStorage.managerData = managerData
    }
  },
  actions: {
    storeLogout({commit}) {
      commit('storeLogout')
      location.reload()
    }
  }
})
